// LoadingScreen para Suspense
import { useBranding } from '@/hooks/useSiteConfig'

export default function LoadingScreen() {
  const [first, second] = useBranding().logoText
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--ink)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: 16,
    }}>
      <div style={{
        fontSize: 24,
        fontWeight: 900,
        letterSpacing: 4,
        textTransform: 'uppercase',
        color: 'var(--white)',
      }}>
        {first}{second && <span style={{ color: 'var(--accent)' }}>{second}</span>}
      </div>
      <div style={{
        width: 40,
        height: 2,
        background: 'var(--accent)',
        animation: 'load 1s ease-in-out infinite alternate',
      }} />
      <style>{`
        @keyframes load {
          from { transform: scaleX(.3); opacity:.4 }
          to   { transform: scaleX(1);  opacity: 1 }
        }
      `}</style>
    </div>
  )
}
